import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import lobbyReducer from './slices/lobbySlice';
import ticTacToeReducer from './slices/ticTacToeSlice';
import battleshipReducer from './slices/battleshipSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    lobby: lobbyReducer,
    ticTacToe: ticTacToeReducer,
    battleship: battleshipReducer,
  },
});
